import { EodSettingsApi, useAPIAction } from "melco-shared-logic";
import { useQueryClient } from "react-query";

export const useAddIntegrationKey = () => {
    const queryClient = useQueryClient();

    return useAPIAction(
        EodSettingsApi,
        async (api, partner?: string, name?: string, url?: string) => {
            const data = await api.eodCreateSettings({
                eodMelcoEodModelsEodSetting: {
                    name: name ?? undefined,
                    partner: partner ?? undefined,
                    url: url ?? undefined
                }

            });

            queryClient.invalidateQueries("eodSettings");

            return {
                successMessages: [],
                data,
            };
        },
        {
            translationPrefix: "eodsettings.actions.add",
            skipErrorHandling: true,
        }
    );
};
